import MicroModal from 'micromodal';
import { eventBus, withPlugins, domEvents } from '@spon/plugins';

function Modal({ node, plugins: { addEvents } }) {
	function onShow(modal) {
		eventBus.emit('modal:onShow', modal);
	}

	function onClose(modal) {
		eventBus.emit('modal:onClose', modal);

		const $video = modal.querySelector('video');
		if ($video) {
			$video.pause();
		}
	}

	MicroModal.init({
		onShow: onShow,
		onClose: onClose,
	});
}

export default withPlugins(domEvents)(Modal);
